import {
  useIsSso,
  useIsStateFarmPartitioned,
} from "../app/Providers/AppContext";

/**
 * In order to use this hook, your component must be wrapped in AppContext.
 * @returns whether user has StateFarm policy and logged-in via SSO.
 */
export const useIsStateFarmSsoLogin = (): boolean => {
  const isSso = useIsSso();
  const hasStateFarmPartition = useIsStateFarmPartitioned();

  return isSso && hasStateFarmPartition;
};
